import "./DetailingList.scss";
import { DetailingItem } from "../DetailingItem/DetailingItem";
import { useTranslation } from "../../../../../../../../../hooks";

const data = [
  { id: 1, ip: "148.22.225.64", traffic: ["25 GB", "5 GB", "10 GB", "4 GB", "2 GB"], date: ["11.10.2024", "11.10.2024", "11.10.2024", "11.10.2024", "11.10.2024"] }
  // { id: 2, ip: "148.22.225.64", traffic: ["25 GB", "5 GB", "10 GB", "4 GB", "2 GB"], date: ["11.10.2024",  "11.10.2024",  "11.10.2024",  "11.10.2024",  "11.10.2024"] },
  // { id: 3, ip: "148.22.225.64", traffic: ["25 GB", "5 GB", "10 GB", "4 GB", "2 GB"], date: ["11.10.2024",  "11.10.2024",  "11.10.2024",  "11.10.2024",  "11.10.2024"] },
  // { id: 4, ip: "148.22.225.64", traffic: ["25 GB", "5 GB", "10 GB", "4 GB", "2 GB"], date: ["11.10.2024",  "11.10.2024",  "11.10.2024",  "11.10.2024",  "11.10.2024"] },
  // { id: 5, ip: "148.22.225.64", traffic: ["25 GB", "5 GB", "10 GB", "4 GB", "2 GB"], date: ["11.10.2024",  "11.10.2024",  "11.10.2024",  "11.10.2024",  "11.10.2024"] }
];

export const DetailingList = () => {
  const { cabinet: { orders: { residential: {
    ip, date, traffic
  } } } } = useTranslation();

  return (
    <div className="detailing-list">
      <div className="detailing-list__head">
        <div className="detailing-list__item detailing-list__column--ip">{ip}</div>
        <div className="detailing-list__item detailing-list__column--traffic">{traffic}</div>
        <div className="detailing-list__item detailing-list__column--date">{date}</div>
      </div>
      <div className="detailing-list__body">
        {data.map((item) => <DetailingItem key={item.id} item={item} />)}
      </div>
    </div>
  );
};
